/**
 * @name: Tslandio
 * @description:._)
 * @author: mullyeux
 * @time: 2020-12-07 17:52:06
 */
// SH TERMINAL REPORT_API
const JoinApi = {
  getCaseDetails: {
    method: 'get',
    url: '/case/file/list'
  },
  getJoinMeetingUrl: {
    method: 'get',
    url: '/v1/meeting/getJoinMeetingUrl'
  },
  delFile: {
    method: 'get',
    url: '/case/file/delete'
  },
  handWriting: {
    method: 'get',
    url: '/case/handWriting'
  },
  nickInfo: {
    method: 'get',
    url: '/netease/add/nickInfo'
  },
  getNickName: {
    method: 'get',
    url: '/netease/nickname'
  },
  joinMeeting: {
    method: 'get',
    url: '/netease/join/meeting'
  },
  delMeeting: {
    method: 'get',
    url: '/netease/delete/meeting'
  },
  handleDownTemplate: {
    method: 'get',
    url: '/netease/download/template'
  },
  startRecord: {
    method: 'get',
    url: '/netease/record/submit'
  },
  stopRecord: {
    method: 'get',
    url: '/netease/record/stop'
  },
  signImage: {
    method: 'get',
    url: '/case/sign/image'
  }
}

export default JoinApi
